import { FC } from "react";
import { NavLink } from "react-router-dom";
import { Box, Flex, Icon, Skeleton, Text } from "@chakra-ui/react";
import { IconBuildingSkyscraper, IconChevronLeft } from "@tabler/icons-react";

export type ClientContextHeaderProps = {
    /** Dummy prop — LeftNavCore's getFragment injects `collapsed` only when `text` is present */
    text?: string;
    collapsed?: boolean;
    clientName?: string;
    colorScheme?: string;
};

export const ClientContextHeader: FC<ClientContextHeaderProps> = ({ collapsed, clientName, colorScheme = "blue" }) => {
    if (collapsed) {
        return (
            <NavLink to="/clients" title={clientName ?? "Select Client"} style={{ display: "block" }}>
                <Flex justify="center" align="center" py="0.6rem" opacity={0.7} _hover={{ opacity: 1 } as any}>
                    <Icon as={IconBuildingSkyscraper} color="white" boxSize={5} />
                </Flex>
            </NavLink>
        );
    }

    return (
        <Box mx="0.75rem" mb="0.5rem" borderRadius="md" border="1px solid" borderColor="whiteAlpha.300" bg="whiteAlpha.100" overflow="hidden">
            <Flex align="center" gap="0.5rem" px="0.75rem" pt="0.6rem" pb="0.3rem">
                <Icon as={IconBuildingSkyscraper} color={`${colorScheme}.200`} boxSize={4} flexShrink={0} />
                {clientName ? (
                    <Text
                        color="white"
                        fontSize="sm"
                        fontWeight="semibold"
                        noOfLines={1}
                        lineHeight="tight"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        title={clientName}
                    >
                        {clientName}
                    </Text>
                ) : (
                    <Skeleton height="14px" width="80px" startColor="whiteAlpha.200" endColor="whiteAlpha.400" borderRadius="sm" />
                )}
            </Flex>

            <NavLink to="/clients" style={{ display: "block" }}>
                {({ isActive }) => (
                    <Flex
                        align="center"
                        gap="0.25rem"
                        px="0.75rem"
                        pb="0.5rem"
                        opacity={isActive ? 1 : 0.6}
                        transition="opacity 0.15s"
                        sx={{ "&:hover": { opacity: 1 } }}
                    >
                        <Icon as={IconChevronLeft} color="whiteAlpha.800" boxSize={3} />
                        <Text fontSize="xs" color="whiteAlpha.800" letterSpacing="0.02em">
                            Select Client
                        </Text>
                    </Flex>
                )}
            </NavLink>
        </Box>
    );
};
